import { render, staticRenderFns } from "./CustomerPage.component.pug?vue&type=template&id=01fd877a&scoped=true&lang=pug&"
import script from "./CustomerPage.component.ts?vue&type=script&lang=ts&"
export * from "./CustomerPage.component.ts?vue&type=script&lang=ts&"
import style0 from "./CustomerPage.component.scss?vue&type=style&index=0&id=01fd877a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd877a",
  null
  
)

export default component.exports